import åpning from "../assets/images/åpning.jpg";
import event1 from "../assets/images/event-1.jpg";
import event2 from "../assets/images/event-2.jpg";
import hyssingen from "../assets/images/hyssingen.jpg";
import event3 from "../assets/images/event-3.jpg";
import vinterkonsert from "../assets/images/vinterkonsert.jpg";
import juleavslutning from "../assets/images/juleavslutning.jpg";
import fylkesmesterskap from "../assets/images/fylkesmesterskap.jpg";

const events = [
  {
    title: "Åpningsarrangement",
    description:
      "6. September hadde vi vårt første arrangement, og alle elever og ansatte på skolen var invitert. Solen skinte og vi startet arrangementet ute finværet. Daglig leder presenterte bedriften og forretningsidèen, rektor holdt tale og klippet snor for å markere åpningen og vi viste frem flotte klær fra bruktbutikken vår med Catwalk. Etter åpningsshowet holdt vi bruktbutikken og salgsvognen åpen, og hadde kjempetilbud med 3 for 2 på allerede lave prises i bruktbutikken.",
    image: åpning,
  },

  {
    title: "Lukket arrangement for venner og familie",
    description:
      "Lørdag 28. september inviterte vi venner og familie til et lukket arrangement for å vise frem bedriften vår. Vi holdt en presentasjon, åpnet bruktbutikken og salgsvognen, og serverte kaffe og kaker. Gjestene fikk også en omvisning på skolen og i nærområdet. Til slutt viste vi reklamefilmer vi har laget i faget kultur og kommunikasjon. Arrangementet ble godt mottatt, og mange ønsker å komme tilbake.",
    image: event1,
  },
  {
    title: "Besøk fra Sandsli vgs",
    description:
      "Fredag 22. november fikk vi besøk av VG1-elever fra salg og reiseliv ved Sandsli vgs. Daglig leder ønsket velkommen og presenterte bedriften. Elevene fikk lunsj fra kantinen, smaksprøver på vår energidrikk, og deltok i en quiz med gavekort som premie. Etterpå utforsket de bruktbutikken vår, prøvde klær og gjorde bærekraftige kjøp. Til slutt fikk de en omvisning på skolen og i nærområdet",
    image: event2,
  },
  {
    title: "Besøk fra Hyssingen",
    description:
      "29. november 2024 fikk vi besøk av elever og ansatte fra Hyssingen produksjonsskole. Med adventstiden i anmarsj ønsket vi velkommen med julekalender, velkomsthilsen og dagens program. Dagen falt på «Black Friday», men som gjenbruksbutikk markerte vi heller Green Friday med «3 for 2» på alle varer. Vi startet med en quiz med gavekort i premie, før gjestene fikk tid til å handle og bli med på omvisning.Flere av våre elever kjente godt til gjestene, noe som skapte en ekstra hyggelig stemning. Dagen ble avsluttet med smaksprøver fra vår salgsvogn til tross for klassisk bergensvær ble det en varm og minneverdig opplevelse for alle.",
    image: hyssingen,
  },
  {
    title: "Besøk fra Stiftelsen Sesam",
    description:
      "13. desember fikk vi besøk av Stiftelsen Sesam. En veldedig organisasjon som driver «Gratisbutikken» for vanskeligstilte. Vi donerte rundt ti sekker med klær fra vår bruktbutikk, som ikke passet våre målgrupper, men som fortsatt var i god stand. Donasjonen ble omtalt i Fanaposten, som skrev en hyggelig sak om samarbeidet. Vi håper klærne får et nytt liv, og ser frem til videre samarbeid med Sesam.",
    image: event3,
  },

  {
    title: "Vinterkonsert",
    description:
      "19. Desember ble det  holdt vinterkonsert på skolen vår. Flinke elever og ansatte sang og spilte nydelig musikk i skolens fellesområde og vi hadde for anledningen bakt gode cookies som vi solgte på vår talle sammen med annen snacks og drikke.",
    image: vinterkonsert,
  },

  {
    title: "Juleavslutning",
    description:
      "Siste skoledag før jul arrangerte vi lykkehjul på skolen. Premiene var varer fra vår bruktbutikk og gavekort. Dette skapte god stemning før alle tok juleferie, og deltakerne var svært fornøyd med de flotte premiene.",
    image: juleavslutning,
  },

  {
    title: "Fylkesmesterskap for ungdomsbedrifter",
    description:
      "19. Mars 2025 deltok vi på Ungt entreprenørskaps fylkesmesterskap for ungdomsbedrifter. Her deltok ungdomsbedrifter fra videregående skoler i hele Vestland fylke. Vi stilte i 6 konkurranser; Markeds og kommunikasjonsprisen, beste regnskap, beste yrkesfaglige bedrift, beste salgsbedrift, beste videopitch og samfunnsbyggerprisen. Etter denne dagen kan vi smykke oss med hele TO førsteplasser og vi vant i tillegg en GULLBILLETT til Norgesmesterskapet for ungdomsbedrifter. Her skal vi delta 25.-26. april.  I fylkesmesterskapet vant forsøteplass i konkurransene: Beste Regnskap Markeds-og kommunikasjonsprisen",
    image: fylkesmesterskap,
  },
];

export default function EventsSection() {
  return (
    <section
      id="arrangementer"
      className="px-4 py-24 max-w-7xl mx-auto scroll-mt-24"
    >
      {/* Header */}
      <div className="text-center mb-16">
        <p className="text-green-600 font-normal mb-2">Opplev Visit Krokeide</p>
        <h2 className="text-4xl font-bold text-gray-900 mb-6">Arrangementer</h2>
        <p className="text-gray-700 mt-4 max-w-xl mx-auto">
          Vi arrangerer jevnlig spennende events knyttet til bærekraft, mat og
          gjenbruk. Besøk oss for smaksprøver, bruktmarked, quizzer, temadager
          og mer!
        </p>
      </div>

      {/* Events */}
      <div className="grid gap-0">
        {events.map((event, index) => (
          <div key={index} className="grid grid-cols-1 md:grid-cols-2">
            {/* Image */}
            <div className={`w-full h-full`}>
              <img
                src={event.image}
                alt={event.title}
                className="w-full h-full object-cover"
              />
            </div>

            {/* Text */}
            <div
              className={`flex flex-col justify-center px-6 py-10 space-y-4 bg-white ${
                index % 2 === 1 ? "md:order-first" : ""
              }`}
            >
              <h3 className="text-2xl font-bold">{event.title}</h3>
              <p className="text-gray-700">{event.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
